import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Progress:
  stepRoomAssignments: 'Room Assignments',
  stepRoomSchedules: 'Booking Details',
  stepCostTrackingCodes: 'Tracking Codes',
  stepPayment: 'Payment Information',
  stepSummary: 'Booking Summary',
  stepBookingDetails: 'Booking Details'
});

export default messages;
